// Total 26 Parts
//---0---|---1---|---2--|---3---|--4--|---5--|----6--- |----7---|---8---|-----------9-------------|---10----|---11----|-12-|--13--|------------14-------------|
// Status|Message|AOPRID|AOPRUID|AORID|AORUID|FirstName|LastName|EmailID|VerifiedEmailOTPSessionID|NextStage|PANNumber|DOB |Gender|PANVerificationAPIRequestID|

//--------------15------------|------16-------|------------17-----------|------------18---------|-----------19---------|------------------------------20------------------------------|
//PANVerificationAPIRequestUID|PANAttemptCount|ExistingTradingClientCode|ExistingDematAccountNos|ExistingClientMobileNo|NeedToContinueWithExistingClientMobileNumberIncaseItsDifferent|

//----------21---------|----------------------------22---------------------------|------------------23--------------------|------------------24-------------------|---------25---------|
//ExistingClientEmailID|NeedToContinueWithExistingClientEmailIDIncaseItsDifferent|VerifiedExistingClientMobileOTPSessionID|VerifiedExistingClientEmailOTPSessionID|BrokerageProductCode|

//--------26--------|---------27----------|----28----|
//DematAMCSchemeCode|ShouldIssueDISBooklet|MiddleName|
    
class AuthInfoContext {
  constructor(context: string = "") {
    const lstParts = context.split("|");
    this.Status = lstParts[0] === "True";
    this.Message = lstParts[1];
    this.AOPRID = parseInt(lstParts[2]);
    this.AOPRUID = lstParts[3];
    this.AORID = parseInt(lstParts[4]);
    this.AORUID = lstParts[5];
    this.FirstName = lstParts[6];
    this.LastName = lstParts[7];
    this.EmailID = lstParts[8];
    this.VerifiedEmailOTPSessionID = parseInt(lstParts[9]);
    this.NextStage = parseFloat(lstParts[10]);
    this.PANNumber = lstParts[11];
    this.DOB = lstParts[12];
    this.Gender = lstParts[13];
    this.PANVerificationAPIRequestID = parseInt(lstParts[14]);
    this.PANVerificationAPIRequestUID = lstParts[15];
    this.PANAttemptCount = parseInt(lstParts[16]);
    this.ExistingTradingClientCode = lstParts[17];
    this.ExistingDematAccountNos = lstParts[18];
    this.ExistingClientMobileNo = lstParts[19];
    this.NeedToContinueWithExistingClientMobileNumberIncaseItsDifferent =
      Boolean(lstParts[20] === "True");
    this.ExistingClientEmailID = lstParts[21];
    this.NeedToContinueWithExistingClientEmailIDIncaseItsDifferent = Boolean(
      lstParts[22] === "True"
    );
    this.VerifiedExistingClientMobileOTPSessionID = lstParts[23];
    this.VerifiedExistingClientEmailOTPSessionID = lstParts[24];
    this.BrokerageProductCode = lstParts[25];
    this.DematAMCSchemeCode = lstParts[26];
    this.ShouldIssueDISBooklet = Boolean(lstParts[27] === "True");
    this.MiddleName = lstParts[28];
  }

  Status: boolean = false;
  Message: string = "";
  AOPRID: number = 0;
  AOPRUID: string = "";
  AORID: number = 0;
  AORUID: string = "";
  FirstName: string = "";
  LastName: string = "";
  EmailID: string = "";
  VerifiedEmailOTPSessionID: number = 0;
  NextStage: number = 0;
  PANNumber: string = "";
  DOB: string = "";
  Gender: string = "";
  PANVerificationAPIRequestID: number = 0;
  PANVerificationAPIRequestUID: string = "";
  PANAttemptCount: number = 0;
  ExistingTradingClientCode: string = "";
  ExistingDematAccountNos: string = "";
  ExistingClientMobileNo: string = "";
  NeedToContinueWithExistingClientMobileNumberIncaseItsDifferent: boolean =
    false;
  ExistingClientEmailID: string = "";
  NeedToContinueWithExistingClientEmailIDIncaseItsDifferent: boolean = false;
  VerifiedExistingClientMobileOTPSessionID: string = "";
  VerifiedExistingClientEmailOTPSessionID: string = "";
  BrokerageProductCode: string = "";
  DematAMCSchemeCode: string = "";
  ShouldIssueDISBooklet: boolean = false;
  MiddleName: string = "";

  // static Stringify(obj: AuthInfoContext) {
  //   let aryString = [];
  //   aryString[0] = obj.Status ? "True" : "False";
  //   aryString[1] = obj.Message;
  //   aryString[2] = obj.AOPRID;
  //   aryString[3] = obj.AOPRUID;
  //   aryString[4] = obj.AORID;
  //   aryString[5] = obj.AORUID;
  //   aryString[6] = obj.FirstName;
  //   aryString[7] = obj.LastName;
  //   aryString[8] = obj.EmailID;
  //   aryString[9] = obj.VerifiedEmailOTPSessionID;
  //   aryString[10] = obj.NextStage;
  //   aryString[11] = obj.PANNumber;
  //   aryString[12] = obj.DOB;
  //   aryString[13] = obj.Gender;
  //   aryString[14] = obj.PANVerificationAPIRequestID;
  //   aryString[15] = obj.PANVerificationAPIRequestUID;
  //   aryString[16] = obj.PANAttemptCount;
  //   aryString[17] = obj.ExistingTradingClientCode;
  //   aryString[18] = obj.ExistingDematAccountNos;
  //   aryString[19] = obj.ExistingClientMobileNo;
  //   aryString[20] =
  //     obj.NeedToContinueWithExistingClientMobileNumberIncaseItsDifferent
  //       ? "True"
  //       : "False";
  //   aryString[21] = obj.ExistingClientEmailID;
  //   aryString[22] =
  //     obj.NeedToContinueWithExistingClientEmailIDIncaseItsDifferent
  //       ? "True"
  //       : "False";
  //   aryString[23] = obj.VerifiedExistingClientMobileOTPSessionID;
  //   aryString[24] = obj.VerifiedExistingClientEmailOTPSessionID;
  //   aryString[25] = obj.BrokerageProductCode;
  //   return aryString.map((item) => (item === undefined ? "" : item)).join("|");
  // }

  // static UpdateContextString(
  //   strContext: string,
  //   objUpdate: Partial<AuthInfoContext>
  // ) {
  //   let objAuthContext = new AuthInfoContext(strContext);
  //   objAuthContext = { ...objAuthContext, ...objUpdate };
  //   return AuthInfoContext.Stringify(objAuthContext);
  // }
}

export default AuthInfoContext;
